import { DSCBTiles } from 'shared-definitions/types'
import { ApiContentBlockTiles } from 'data-source/types.wp'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { tileMapper } from 'data-source/mappers/tileMapper'

export function cbTiles(input: ApiContentBlockTiles, opts: PLinkMapperOpts): DSCBTiles {
  return {
    resource: 'cb-tiles',
    title: input.title,
    pLink: input.slug ? pLinkMapper(input.slug, opts) : null,
    tiles: input.items.flatMap(i => {
      const r = tileMapper(i, opts)
      if (!r) {
        return []
      }

      return r
    }),
  }
}
